import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';

const useStyles = createUseStyles(
  {
    container: {
      gap: Spacings.s8,
      display: 'flex',
      width: '100%',

      '@media screen and (max-width: 1023px)': {
        flexDirection: 'column',
        gap: Spacings.s24,
      },
    },
    switch: {
      marginBottom: Spacings.s16,
    },
    card: {
      flexBasis: '100%',
      '&:first-child': {
        borderBottomLeftRadius: CornerRadius.r8,
        borderTopLeftRadius: CornerRadius.r8,
      },
      '&:last-child': {
        borderBottomRightRadius: CornerRadius.r8,
        borderTopRightRadius: CornerRadius.r8,
      },
      '@media screen and (max-width: 1023px)': {
        borderRadius: CornerRadius.r8,
      },
    },
    cardSkeleton: {
      minHeight: 520,
    },
  },
  { name: 'pa-monetization-pricing-cards' },
);

export default useStyles;
